unit Home_View;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.WebCtrls, WEBLib.ExtCtrls, WEBLib.REST, Data.DB,

  jsdelphisystem,   //Usado no Projeto bom (verificar sua utilidade)

  WEBLib.CDS, WEBLib.DBCtrls, WEBLib.Lists;

type
  THomeView = class(TForm)
    Datas_Con: TClientConnection;
    execAPIs: THttpRequest;
    emailuser: THTMLSpan;
    Datas_DSET: TClientDataSet;
    DashINV_IdDi: TIntegerField;
    DashINV_DataInv: TDateTimeField;
    DashINV_SItens: TIntegerField;
    DashINV_SRuptura: TIntegerField;
    DashINV_Consolida: TIntegerField;
    procedure WebFormShow(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure idloadtableClick(Sender: TObject);
  private
    { Private declarations }


    //Podemos guardar este monte de variáveis para controle do sistema
    //S:\ContFat\Disco00_Athenas\Projetos\TMS_Core\Projetos\TMS-WEB-Core-TemplateDemo-main\units\UnitMain.dfm
    App_Name: String;
    App_Short: String;
    App_Version: String;
    App_Release: String;
    App_Start: TDateTime;
//    App_Start_UTC: TDateTime;
//    App_Session: String;
//
//    App_TZ: String;
//    App_TZOffset: Integer;
//    App_LogDateTimeFormat: String;
//    App_DisplayDateTimeFormat: String;
//    App_LogDateFormat: String;
//    App_DisplayDateFormat: String;
//    App_LogTimeFormat: String;
//    App_DisplayTimeFormat: String;
//
//    App_ChatBotName: String;
//
//    Server_URL: String;
//
//    LoggedIn: Boolean;
//    ActivityDetected: Boolean;
//    IconSet: String;
//
//    ActionLog: TStringList;
//    ActionLogCurrent: TStringList;
//    LogVisible: Boolean;
//
//    CurrentForm: TWebForm;
//    CurrentFormName: String;
//    CurrentFormNiceName: String;
//    CurrentFormShortName: String;
//    CurrentFormIcon: String;
//
//    CurrentSubForm: TWebForm;
//    CurrentSubFormName: String;
//    CurrentSubFormNiceName: String;
//    CurrentSubFormShortName: String;
//    CurrentSubFormIcon: String;
//
//    JWT: String;
//    JWT_Expiry: TDateTime;
//    Remember: Boolean;
//
//    User_FirstName: String;
//    User_MiddleName: String;
//    User_LastName: String;
//    User_EMail: String;
//    User_Photo: String;
//    User_Account: String;
//
//    User_Roles: TStringList;
//    Roles: String;
//    Role_Administrator: Boolean;
//
//    ToastCount: Integer;
//
//    // Back/Forward History
//    StartPosition: Integer;
//    Position: Integer;
//    URL: String;

//    // Screen Recording
//    RecordingSession: Boolean;
//    CaptureData: JSValue;
    //S:\ContFat\Disco00_Athenas\Projetos\TMS_Core\Projetos\TMS-WEB-Core-TemplateDemo-main\units\UnitMain.dfm


    //Variáveis do gráfico do DashBoard dos Inventários
    sTItens,        //Série dos Totais do Itens
    sTAcur_Itens,   //Série dos Totais do Itens - Ajustes (Acurácia)
    sPerc_Itens,    //Série dos percentuais do mês = 1 - (Ajustes / Itens) * 100
    sXaxis          //Labels do eixo X (exemplo: '31/05/2025 92.0%')
    : string;
  public
    { Public declarations }

  protected procedure LoadDFMValues; override; end;

var
  HomeView: THomeView;

implementation

{$R *.dfm}

uses
  Login_View;

procedure THomeView.idloadtableClick(Sender: TObject);
var
      xURL,
      Criterio: string;
begin

      xURL:= '';
      Criterio:= '';

      try
        Datas_Con.Active:= false;

        //http://localhost:8082/api/inventario/datas?offset=0&fetch=4
        xURL := LoginView.Server_URL + 'inventario/dashboard?offset=0&fetch=12';
        //http://localhost:8083/api/carga?offset=0&fetch=10&iduser=47&qtdesaldo%3E0

        //MousePointer.Cursor := -11;
        if Criterio = '' then
        begin
          //UTF8Encode(Server_URL);
          Datas_Con.URI := xURL;
        end else begin

          //Datas_Con.URI := Server_URL+'&'+xCampo+'='+Interm;
          Datas_Con.URI := xURL;
          // ' = %27
          // % = %25;
          // % = &#37;
          //produtos?offset=0&fetch=100&gestao=0
        end;
        Datas_Con.Active:= true;
      finally
        //Screen.Cursor := 0;
      end;
//B- Pesquisa as Datas

end;

procedure THomeView.WebFormCreate(Sender: TObject);
begin
    // Application Information
    App_Name := 'TMS WEB Core Template Demo';
    App_Short := 'Template';
    App_Version := '1.2';
    App_Release := '2022-Mar-13';
    App_Start := Now();
    //App_Start_UTC := TTimeZone.Local.ToUniversalTime(Now);
end;

procedure THomeView.WebFormShow(Sender: TObject);
begin
    //01- Seta Email do Usuário
    emailuser.HTML.Clear;
    emailuser.HTML.Add(LoginView.EditEmail.Text);


    //Zera Variáveis do Gráfico
    sTItens       := '';
    sTAcur_Itens  := '';
    sPerc_Itens   := '';
    sXaxis        := '';

    //idloadtableClick(Self); //Carrega dados

end;


procedure THomeView.LoadDFMValues;
begin
  inherited LoadDFMValues;

  emailuser := THTMLSpan.Create('email_user');
  Datas_Con := TClientConnection.Create(Self);
  execAPIs := THttpRequest.Create(Self);
  Datas_DSET := TClientDataSet.Create(Self);
  DashINV_IdDi := TIntegerField.Create(Self);
  DashINV_DataInv := TDateTimeField.Create(Self);
  DashINV_SItens := TIntegerField.Create(Self);
  DashINV_SRuptura := TIntegerField.Create(Self);
  DashINV_Consolida := TIntegerField.Create(Self);

  emailuser.BeforeLoadDFMValues;
  Datas_Con.BeforeLoadDFMValues;
  execAPIs.BeforeLoadDFMValues;
  Datas_DSET.BeforeLoadDFMValues;
  DashINV_IdDi.BeforeLoadDFMValues;
  DashINV_DataInv.BeforeLoadDFMValues;
  DashINV_SItens.BeforeLoadDFMValues;
  DashINV_SRuptura.BeforeLoadDFMValues;
  DashINV_Consolida.BeforeLoadDFMValues;
  try
    Name := 'HomeView';
    Width := 733;
    Height := 549;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    emailuser.SetParentComponent(Self);
    emailuser.Name := 'emailuser';
    emailuser.Left := 576;
    emailuser.Top := 8;
    emailuser.Width := 140;
    emailuser.Height := 25;
    emailuser.HeightStyle := ssAuto;
    emailuser.WidthStyle := ssAuto;
    emailuser.ChildOrder := 13;
    emailuser.ElementPosition := epIgnore;
    emailuser.ElementFont := efCSS;
    emailuser.Role := '';
    Datas_Con.SetParentComponent(Self);
    Datas_Con.Name := 'Datas_Con';
    Datas_Con.Active := False;
    Datas_Con.DataNode := 'data';
    Datas_Con.Delimiter := ';';
    Datas_Con.Left := 152;
    Datas_Con.Top := 72;
    execAPIs.SetParentComponent(Self);
    execAPIs.Name := 'execAPIs';
    execAPIs.Left := 155;
    execAPIs.Top := 185;
    Datas_DSET.SetParentComponent(Self);
    Datas_DSET.Name := 'Datas_DSET';
    Datas_DSET.Connection := Datas_Con;
    Datas_DSET.Left := 152;
    Datas_DSET.Top := 128;
    DashINV_IdDi.SetParentComponent(Datas_DSET);
    DashINV_IdDi.Name := 'DashINV_IdDi';
    DashINV_IdDi.FieldName := 'iddi';
    DashINV_DataInv.SetParentComponent(Datas_DSET);
    DashINV_DataInv.Name := 'DashINV_DataInv';
    DashINV_DataInv.FieldName := 'datainv';
    DashINV_SItens.SetParentComponent(Datas_DSET);
    DashINV_SItens.Name := 'DashINV_SItens';
    DashINV_SItens.FieldName := 'sitens';
    DashINV_SRuptura.SetParentComponent(Datas_DSET);
    DashINV_SRuptura.Name := 'DashINV_SRuptura';
    DashINV_SRuptura.FieldName := 'sruptura';
    DashINV_Consolida.SetParentComponent(Datas_DSET);
    DashINV_Consolida.Name := 'DashINV_Consolida';
    DashINV_Consolida.FieldName := 'consolida';
  finally
    emailuser.AfterLoadDFMValues;
    Datas_Con.AfterLoadDFMValues;
    execAPIs.AfterLoadDFMValues;
    Datas_DSET.AfterLoadDFMValues;
    DashINV_IdDi.AfterLoadDFMValues;
    DashINV_DataInv.AfterLoadDFMValues;
    DashINV_SItens.AfterLoadDFMValues;
    DashINV_SRuptura.AfterLoadDFMValues;
    DashINV_Consolida.AfterLoadDFMValues;
  end;
end;

end.
